import io from 'socket.io-client';
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';

class FeathersClient {
  constructor() {
    const socket = io(process.env.API_SOCKET_CONNECTION_URL, {
      transports: ['websocket', 'polling'],
      timeout: 150000
    });

    this._app = feathers();

    this._app.configure(socketio(socket));
    this._app.configure(
      auth({
        timeout: 150000,
        header: 'Authorization', // the default authorization header for REST
        prefix: '', // if set will add a prefix to the header value. for example if prefix was 'JWT' then the header would be 'Authorization: JWT eyJ0eXAiOiJKV1QiLCJhbGciOi...'
        storageKey: 'feathers-jwt', // the key to store the accessToken in localstorage or AsyncStorage on React Native
        storage: window.localStorage // Passing a WebStorage-compatible object to enable automatic storage on the client.
      })
    );
  }

  get app() {
    return this._app;
  }

  get io() {
    return this._app.io;
  }

  get authenticate() {
    return this._app.authenticate;
  }

  get passport() {
    return this._app.passport;
  }
}

export default FeathersClient;



// WEBPACK FOOTER //
// ./src/services/FeathersClient.js